import { useTheme, useMediaQuery } from "@mui/material";
import AnalyticsMobile from "./AnalyticsMobile";
import AnalyticsDesktop from "./AnalyticsDesktop";

export default function Analytics() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return isMobile ? <AnalyticsMobile /> : <AnalyticsDesktop />;
}
